function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ListingFieldEditTemplate = require('./listing-field-edit.template');
var EXCLUDED_WEB3_TICKERS = new Set(['ERC-SAITO', 'BEP-SAITO']);
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function addStoreWeb3Ticker(tickers, ticker) {
  var value = String(ticker || '').trim().toUpperCase();
  if (!value || value === 'SAITO' || EXCLUDED_WEB3_TICKERS.has(value) || tickers.includes(value)) {
    return;
  }
  tickers.push(value);
}
function returnStoreWeb3Tickers(app) {
  var _app$modules, _app$modules$returnMo, _app$modules2;
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SAITO';
  var tickers = ['SAITO'];
  var mixin = app === null || app === void 0 || (_app$modules = app.modules) === null || _app$modules === void 0 || (_app$modules$returnMo = _app$modules.returnModule) === null || _app$modules$returnMo === void 0 ? void 0 : _app$modules$returnMo.call(_app$modules, 'Mixin');
  var currencies = Array.isArray(mixin === null || mixin === void 0 ? void 0 : mixin.available_currencies) ? mixin.available_currencies : [];
  var _iterator = _createForOfIteratorHelper(currencies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var currency = _step.value;
      addStoreWeb3Ticker(tickers, currency === null || currency === void 0 ? void 0 : currency.ticker);
    }
    // Installed Mixin payment cryptos stay selectable before a priced currency
    // reply arrives, so a listing can be priced in third-party crypto.
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var installed = Array.isArray(mixin === null || mixin === void 0 ? void 0 : mixin.crypto_mods) ? mixin.crypto_mods : [];
  var _iterator2 = _createForOfIteratorHelper(installed),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _crypto = _step2.value;
      addStoreWeb3Ticker(tickers, _crypto === null || _crypto === void 0 ? void 0 : _crypto.ticker);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (tickers.length === 1 && typeof (app === null || app === void 0 || (_app$modules2 = app.modules) === null || _app$modules2 === void 0 ? void 0 : _app$modules2.respondTo) === 'function') {
    var offered = app.modules.respondTo('mixin-crypto');
    var list = Array.isArray(offered) ? offered : offered ? [offered] : [];
    var _iterator3 = _createForOfIteratorHelper(list),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var crypto = _step3.value;
        addStoreWeb3Ticker(tickers, crypto === null || crypto === void 0 ? void 0 : crypto.ticker);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  var selected = String(current || '').trim().toUpperCase();
  if (selected && !tickers.includes(selected)) {
    tickers.push(selected);
  }
  return tickers;
}
function storeWeb3TickersAnswered(app) {
  var _app$modules3, _app$modules3$returnM;
  if (requestStoreWeb3Tickers.resolved) {
    return true;
  }
  var mixin = app === null || app === void 0 || (_app$modules3 = app.modules) === null || _app$modules3 === void 0 || (_app$modules3$returnM = _app$modules3.returnModule) === null || _app$modules3$returnM === void 0 ? void 0 : _app$modules3$returnM.call(_app$modules3, 'Mixin');
  var currencies = mixin === null || mixin === void 0 ? void 0 : mixin.available_currencies;
  // null is only assigned when a reply arrives without a currency list.
  // [] is also the value before any reply, so it does not count as an answer.
  if (currencies === null) {
    requestStoreWeb3Tickers.resolved = true;
    return true;
  }
  if (Array.isArray(currencies) && currencies.length) {
    requestStoreWeb3Tickers.resolved = true;
    return true;
  }
  return false;
}
function rememberStoreWeb3TickerResponse(app) {
  var _app$connection;
  if (requestStoreWeb3Tickers.listening || !(app !== null && app !== void 0 && (_app$connection = app.connection) !== null && _app$connection !== void 0 && _app$connection.on)) {
    return;
  }
  requestStoreWeb3Tickers.listening = true;
  app.connection.on('saito-purchase-cryptos', function () {
    requestStoreWeb3Tickers.resolved = true;
    requestStoreWeb3Tickers.pending = false;
  });
}
function requestStoreWeb3Tickers(app) {
  var _app$modules4, _app$modules4$returnM, _mixin$buysaito_peer;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force;
  var mixin = app === null || app === void 0 || (_app$modules4 = app.modules) === null || _app$modules4 === void 0 || (_app$modules4$returnM = _app$modules4.returnModule) === null || _app$modules4$returnM === void 0 ? void 0 : _app$modules4$returnM.call(_app$modules4, 'Mixin');
  var peerKey = mixin === null || mixin === void 0 || (_mixin$buysaito_peer = mixin.buysaito_peer) === null || _mixin$buysaito_peer === void 0 ? void 0 : _mixin$buysaito_peer.publicKey;
  if (!peerKey) {
    return;
  }
  rememberStoreWeb3TickerResponse(app);
  if (force) {
    requestStoreWeb3Tickers.resolved = false;
    requestStoreWeb3Tickers.pending = false;
  } else if (storeWeb3TickersAnswered(app) || requestStoreWeb3Tickers.pending) {
    return;
  }
  requestStoreWeb3Tickers.pending = true;
  app.network.sendRequestAsTransaction('buysaito available currencies', null, null, peerKey);
}
requestStoreWeb3Tickers.resolved = false;
requestStoreWeb3Tickers.pending = false;
requestStoreWeb3Tickers.listening = false;
requestStoreWeb3Tickers.reset = function () {
  requestStoreWeb3Tickers.resolved = false;
  requestStoreWeb3Tickers.pending = false;
  requestStoreWeb3Tickers.listening = false;
};
var ListingFieldEdit = /*#__PURE__*/function () {
  function ListingFieldEdit(app, mod) {
    var _this = this;
    _classCallCheck(this, ListingFieldEdit);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.onSave = null;
    this.app.connection.on('saito-purchase-cryptos', function () {
      _this.refreshTickerSelect();
    });
  }
  return _createClass(ListingFieldEdit, [{
    key: "refreshTickerSelect",
    value: function refreshTickerSelect() {
      var select = document.getElementById('saito-overlay-form-ticker');
      if (!select) {
        return;
      }
      var current = select.value || 'SAITO';
      var tickers = returnStoreWeb3Tickers(this.app, current);
      select.innerHTML = tickers.map(function (ticker) {
        return "<option value=\"".concat(escapeHtml(ticker), "\"").concat(ticker === current ? ' selected' : '', ">").concat(escapeHtml(ticker), "</option>");
      }).join('');
    }

    /**
     * @param {object} options
     * @param {string} options.title
     * @param {string} options.value
     * @param {boolean} [options.multiline]
     * @param {string} [options.inputType]
     * @param {string} [options.placeholder]
     * @param {(value: string) => void|boolean} options.onSave - return false to keep overlay open
     */
  }, {
    key: "render",
    value: function render() {
      var _options$value;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.onSave = options.onSave || null;
      this.overlay.show(ListingFieldEditTemplate({
        title: options.title || 'Edit',
        value: (_options$value = options.value) !== null && _options$value !== void 0 ? _options$value : '',
        multiline: !!options.multiline,
        inputType: options.inputType || 'text',
        placeholder: options.placeholder || '',
        tickers: options.tickers || null,
        ticker: options.ticker || 'SAITO'
      }));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _form$querySelector,
        _this2 = this,
        _form$querySelector2;
      var form = document.querySelector('.store-listing-field-edit');
      var input = document.getElementById('saito-overlay-form-input');
      if (!form || !input) {
        return;
      }
      input.focus();
      if (typeof input.select === 'function') {
        input.select();
      }
      (_form$querySelector = form.querySelector('[data-action="cancel"]')) === null || _form$querySelector === void 0 || _form$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.overlay.close();
      });
      (_form$querySelector2 = form.querySelector('.saito-overlay-form-submit')) === null || _form$querySelector2 === void 0 || _form$querySelector2.addEventListener('click', function (e) {
        var _input$value, _form$querySelector3;
        e.preventDefault();
        var value = (_input$value = input.value) !== null && _input$value !== void 0 ? _input$value : '';
        var ticker = ((_form$querySelector3 = form.querySelector('[data-field="ticker"]')) === null || _form$querySelector3 === void 0 ? void 0 : _form$querySelector3.value) || '';
        if (typeof _this2.onSave === 'function') {
          var ok = _this2.onSave(value, ticker);
          if (ok === false) {
            return;
          }
        }
        _this2.overlay.close();
      });
      form.addEventListener('submit', function (e) {
        var _form$querySelector4;
        e.preventDefault();
        (_form$querySelector4 = form.querySelector('.saito-overlay-form-submit')) === null || _form$querySelector4 === void 0 || _form$querySelector4.click();
      });
    }
  }]);
}();
module.exports = ListingFieldEdit;
module.exports.returnStoreWeb3Tickers = returnStoreWeb3Tickers;
module.exports.requestStoreWeb3Tickers = requestStoreWeb3Tickers;
module.exports.storeWeb3TickersAnswered = storeWeb3TickersAnswered;